var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFloorPalletizedLoaded = function SvgFloorPalletizedLoaded(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 62,
    viewBox: "0 0 118 62",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.32 10.438l4.31-4.32-4.31-4.32L1.647.47l5.647 5.647-5.647 5.647z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4F7FA",
    stroke: "#3F536E",
    strokeWidth: 2,
    d: "M42.652 54.033H4.317V5.203h38.335v48.83zm3.318 3.21V1.884H1v55.357h44.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F7FA",
    d: "M2.818 3.758h41.333v52.606H2.818z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.758 4.697)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.591,
    height: 12.591,
    x: 0.75,
    y: 0.75,
    fill: "#F4F7FA",
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.591,
    height: 12.591,
    x: 0.75,
    y: 36.447,
    fill: "#F4F7FA",
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.591,
    height: 12.591,
    x: 13.902,
    y: 36.447,
    fill: "#F4F7FA",
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.591,
    height: 12.591,
    x: 26.114,
    y: 36.447,
    fill: "#F4F7FA",
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.591,
    height: 12.591,
    x: 13.902,
    y: 0.75,
    fill: "#F4F7FA",
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.591,
    height: 12.591,
    x: 0.75,
    y: 25.174,
    fill: "#F4F7FA",
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.591,
    height: 12.591,
    x: 13.902,
    y: 25.174,
    fill: "#F4F7FA",
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.591,
    height: 12.591,
    x: 26.114,
    y: 25.174,
    fill: "#F4F7FA",
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.591,
    height: 12.591,
    x: 26.114,
    y: 0.75,
    fill: "#F4F7FA",
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.591,
    height: 12.591,
    x: 0.75,
    y: 12.962,
    fill: "#F4F7FA",
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.591,
    height: 12.591,
    x: 13.902,
    y: 12.962,
    fill: "#F4F7FA",
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.591,
    height: 12.591,
    x: 26.114,
    y: 12.962,
    fill: "#F4F7FA",
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.758,
    height: 2.818,
    x: 7.515,
    y: 45.091,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.758,
    height: 2.818,
    x: 19.727,
    y: 45.091,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.758,
    height: 2.818,
    x: 32.879,
    y: 45.091,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.758,
    height: 2.818,
    x: 7.515,
    y: 32.879,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.758,
    height: 2.818,
    x: 19.727,
    y: 32.879,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.758,
    height: 2.818,
    x: 32.879,
    y: 32.879,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.758,
    height: 2.818,
    x: 7.515,
    y: 20.667,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.758,
    height: 2.818,
    x: 19.727,
    y: 20.667,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.758,
    height: 2.818,
    x: 32.879,
    y: 20.667,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.758,
    height: 2.818,
    x: 7.515,
    y: 7.515,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.758,
    height: 2.818,
    x: 19.727,
    y: 7.515,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.758,
    height: 2.818,
    x: 32.879,
    y: 7.515,
    fill: "#0093EE",
    rx: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F7FA",
    stroke: "#3F536E",
    strokeWidth: 2,
    d: "M1 57.364h6.455V61H1zM39.515 57.364h6.455V61h-6.455z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#CBAB87",
    transform: "translate(.582 25.804)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.13,
    height: 1.558,
    rx: 0.779
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.13,
    height: 1.558,
    y: 2.961,
    rx: 0.779
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.819.779h1.492V4.14h-1.492zM1.492.779h1.492V4.14H1.492zM20.145.779h1.492V4.14h-1.492z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#CBAB87",
    transform: "translate(.582 57.39)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.13,
    height: 1.558,
    rx: 0.779
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.13,
    height: 1.558,
    y: 2.961,
    rx: 0.779
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.819.779h1.492V4.14h-1.492zM1.492.779h1.492V4.14H1.492zM20.145.779h1.492V4.14h-1.492z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#CBAB87",
    transform: "translate(25.853 25.804)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.13,
    height: 1.558,
    rx: 0.779
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.13,
    height: 1.558,
    y: 2.961,
    rx: 0.779
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.819.779h1.492V4.14h-1.492zM1.492.779h1.492V4.14H1.492zM20.145.779h1.492V4.14h-1.492z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#CBAB87",
    transform: "translate(25.853 57.39)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.13,
    height: 1.558,
    rx: 0.779
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.13,
    height: 1.558,
    y: 2.961,
    rx: 0.779
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.819.779h1.492V4.14h-1.492zM1.492.779h1.492V4.14H1.492zM20.145.779h1.492V4.14h-1.492z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 10.524,
    height: 11.121,
    x: 1.557,
    y: 12.131,
    fill: "#F4F7FA",
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.317,
    height: 2.176,
    x: 6.467,
    y: 18.688,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.524,
    height: 11.121,
    x: 11.964,
    y: 12.131,
    fill: "#F4F7FA",
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.317,
    height: 2.176,
    x: 16.873,
    y: 18.688,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.524,
    height: 11.121,
    x: 1.557,
    y: 43.718,
    fill: "#F4F7FA",
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.317,
    height: 2.176,
    x: 6.467,
    y: 50.274,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.524,
    height: 11.121,
    x: 11.964,
    y: 43.718,
    fill: "#F4F7FA",
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.317,
    height: 2.176,
    x: 16.873,
    y: 50.274,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.524,
    height: 11.121,
    x: 26.828,
    y: 12.131,
    fill: "#F4F7FA",
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.317,
    height: 2.176,
    x: 31.737,
    y: 18.688,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.524,
    height: 11.121,
    x: 37.234,
    y: 12.131,
    fill: "#F4F7FA",
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.317,
    height: 2.176,
    x: 42.143,
    y: 18.688,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.524,
    height: 11.121,
    x: 26.828,
    y: 43.718,
    fill: "#F4F7FA",
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.317,
    height: 2.176,
    x: 31.737,
    y: 50.274,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.524,
    height: 11.121,
    x: 37.234,
    y: 43.718,
    fill: "#F4F7FA",
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.317,
    height: 2.176,
    x: 42.143,
    y: 50.274,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.524,
    height: 11.121,
    x: 1.557,
    y: 1.374,
    fill: "#F4F7FA",
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.317,
    height: 2.176,
    x: 6.467,
    y: 7.931,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.524,
    height: 11.121,
    x: 11.964,
    y: 1.374,
    fill: "#F4F7FA",
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.317,
    height: 2.176,
    x: 16.873,
    y: 7.931,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.524,
    height: 11.121,
    x: 1.557,
    y: 32.961,
    fill: "#F4F7FA",
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.317,
    height: 2.176,
    x: 6.467,
    y: 39.517,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.524,
    height: 11.121,
    x: 11.964,
    y: 32.961,
    fill: "#F4F7FA",
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.317,
    height: 2.176,
    x: 16.873,
    y: 39.517,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.524,
    height: 11.121,
    x: 26.828,
    y: 1.374,
    fill: "#F4F7FA",
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.317,
    height: 2.176,
    x: 31.737,
    y: 7.931,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.524,
    height: 11.121,
    x: 37.234,
    y: 1.374,
    fill: "#F4F7FA",
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.317,
    height: 2.176,
    x: 42.143,
    y: 7.931,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.524,
    height: 11.121,
    x: 26.828,
    y: 32.961,
    fill: "#F4F7FA",
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.317,
    height: 2.176,
    x: 31.737,
    y: 39.517,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.524,
    height: 11.121,
    x: 37.234,
    y: 32.961,
    fill: "#F4F7FA",
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.317,
    height: 2.176,
    x: 42.143,
    y: 39.517,
    fill: "#0093EE",
    rx: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.95 23)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0093EE",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 4,
    transform: "translate(-7.2 -4.8)"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFloorPalletizedLoaded, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/floor_palletized_loaded.dd6a0006.svg";
export { ForwardRef as ReactComponent };